<template>
  <div class="nd-select">
    <van-popup
      v-model="visible"
      position="bottom"
    >
      <van-picker
        :itemHeight="120"
        :columns="pickerData"
        :showToolbar="showToolbar"
        :title="title || label"
        :confirmButtonText="confirmText"
        :cancelButtonText="cancelText"
        @confirm="confirm"
        @cancel="visible = false"
        @change="selectChange"
        ref="picker"
        valueKey="name"
        class="nd-select-picker"
      >
      </van-picker>
    </van-popup>
    <div class="nd-inner-input" @click="onClick">
      <input
        type="text"
        class="nd-select-text"
        :class="textAlign"
        :placeholder="placeholder"
        :readonly="readonly"
        :disabled="!editable"
        :value="bindText && showFormatter(bindText)"
        :name="name"
        ref="input"
      >
      <label :for="name" v-if="label">{{ label }}</label>
      <i class="arrow-icon"></i>
      <input
        type="hidden"
        :value="currentValue"
      >
    </div>
  </div>
</template>
<script>
    /**
     * 支持双向绑定：使用 v-model 绑定表单值
     * 支持popup-picker所有事件
     */
import { Popup, Picker } from 'vant'
export default {
  name: 'nd-select',

  components: {
    'van-popup': Popup,
    'van-picker': Picker
  },

  data () {
    return {
      currentValue: this.value,
      bindText: '',
      visible: false
    }
  },

  props: {
    type: {
      type: String,
      default: 'text'
    },
    name: String,
    placeholder: {
      type: String,
      default: '请选择'
    },
    label: String,
    // eslint-disable-next-line vue/require-prop-type-constructor
    value: String | Number,
    data: Array,
    editable: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: true
    },
    title: String,
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '确定'
    },
    showToolbar: {
      type: Boolean,
      default: true
    },
    textAlign: {
      type: String,
      default: 'right'
    },
    valueKey: {
      type: Array,
      default: () => ['value', 'name']
    },
    mutilple: Boolean,
    showFormatter: {
      type: Function,
      default: format => format
    },
    beforeClick: {
      type: Function,
      default: () => {
        return Promise.resolve(true)
      }
    }
  },

  watch: {
    value (val) {
      this.setCurrentValue(val)
    },

    bindValue (val) {
      this.setCurrentValue(val)
    },

    visible (val) {
      if (val) {
        this.$emit('open')
      } else {
        this.$emit('close')
      }
    }
  },

  created () {
    if (this.data && this.data.length) {
      this.setInitText(this.value, this.data)
    } else {
      this.$watch('data', (list) => {
        this.setInitText(this.value, list)
      })
      this.$watch('value', (value) => {
        this.setInitText(value, this.data)
      })
    }
  },

  computed: {
    pickerData () {
      if (this.data && this.data.length > 0) {
        return this.data.map(item => {
          // console.log( {
          //     name: item[this.valueKey[1]],
          //     value: item[this.valueKey[0]],
          //     item
          // })
          return {
            name: item[this.valueKey[1]],
            value: item[this.valueKey[0]],
            item
          }
        })
      }
      return []
    }
  },

  methods: {
    setCurrentValue (value) {
      if (value === this.currentValue) return
      this.$emit('input', value)
      this.$refs['input'].dispatchEvent(new Event('input'))
      this.$refs['input'].dispatchEvent(new Event('change'))
      this.currentValue = value
      this.bindValue = value
      if (value === '') {
        this.currentValue = value
        this.bindText = ''
      } else {
        this.setInitText(value, this.data)
      }
    },

    confirm () {
      const values = this.$refs['picker'].getValues()
      if (this.bindText !== values[0].name) {
        const originData = values[0].item
        this.$emit('change', originData)
      }
      // this.bindText = values[0].name
      this.setCurrentValue(values[0].value)
      this.visible = false
    },

    // 设置初始化显示文本
    setInitText (value, list) {
      if (list && list instanceof Array) {
        let item = list.filter(item => item[this.valueKey[0]] === value)[0]
        this.bindText = item && item[this.valueKey[1]]
      }
    },

    onClick () {
      this.beforeClick()
        .then(open => {
          if (open) {
            this.visible = true
          }
          this.$emit('click')
          this.$nextTick(() => {
            // fix:使picker选中目前select选中的值
            let idx = 0
            this.pickerData.forEach((item, index) => {
              if (item.value === this.value) {
                idx = index
              }
            })

            this.$refs['picker'].setIndexes([idx])
          })
        })
    },

    selectChange () {
      this.$emit('scroll')
    }
  }
}
</script>
<style lang="less">
@import "../../assets/less/mixin.less";

    .nd-select {
        position: relative;
        height: 100%;
        width: 100%;

        .nd-inner-input {
            height: 100%;
            width: 100%;
        }

        input {
            border: none;
            outline: none;
            width: 100%;
            height: 100%;
            color: @fc1;
            font-size: 28px;
            background: transparent;
            font-family: 'PingFangSC-Regular';
            font-weight: 400;
            &.nd-select-text {
                padding-right: 20px;
                &.right {
                    text-align: right;
                }
                &.center {
                    text-align: center;
                }
            }
            &::-moz-placeholder { color: @fc4; -webkit-text-fill-color: @fc4;}
            &:-moz-placeholder { color: @fc4; -webkit-text-fill-color: @fc4;}
            &::-webkit-input-placeholder { color: @fc4; -webkit-text-fill-color: @fc4;}
            &:-ms-input-placeholder { color:@fc4; -webkit-text-fill-color: @fc4;}
            &[disabled], &:disabled, &.disabled {
                background-color: transparent;
                color: @fc1!important;
                -webkit-text-fill-color: @fc1;
                -webkit-opacity: 1;
                opacity: 1;
            }
        }

        label {
            position: absolute;
            height: 100%;
            left: 0;
            top: 0;
            font-size: 30px;
            background-color: #fff;
            font-family: 'PingFangSC-Regular';
            font-weight: 400;
        }

        .arrow-icon {
            position: absolute;
            top: 50%;
            right: 0;
            height: 20px;
            margin-top: -10px;
            width: 11px;
            background-image: url(../nd-cell/images/arrow.png);
            background-size: 100% 100%;
            display: block;
        }

        .van-picker__title {
            font-size: 28px;
        }

        .van-popup--bottom {
            border-radius: 24px 24px 0 0;
            overflow: hidden;
        }

        .nd-select-picker {
            .van-picker__toolbar {
                height: 88px;
                line-height: 88px;
                padding: 0 30px;
            }
            .van-picker__confirm {
                color: @theme;
                font-size: 28px;
            }
            .van-picker__cancel {
                color: @fc2;
                font-size: 28px;
            }
            .van-picker-column {
                font-size: 28px;
            }
            .van-picker-column__item--selected {
                color: @theme;
            }
        }
    }
</style>
